import { createAction } from 'redux-actions';
export const putEntities = createAction(`@@entities/PUT`, (payload)=>payload);
